/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react";

// Contexts
import { DataContext } from "~/contexts/Data";

// Internal components
import InternalOrExternalLink from "~/components/InternalOrExternalLink";
import LazyBlur from "~/components/LazyBlur";
import AnimateMount from "~/components/AnimateMount";

const NewsGrid = ({
  items,
  icon = null,
  showUrl = false,
  minHeight = "",
  limit = undefined,
  hideText,
}) => {
  const { hyphenParse } = useContext(DataContext);

  const hasImage = (item) => {
    if (item.bilder?.[0]?.umbracoFile) {
      return {
        url: item.bilder[0].umbracoFile,
        alt: item.bilder[0].title || item.title,
      };
    }

    const seo = item.seoImage?.umbracoFile;
    const img = item.img?.umbracoFile;
    const fallback = seo || img;

    if (fallback) {
      return {
        url: fallback,
        alt: item.seoImage?.title || item.img?.title || item.title,
      };
    }

    return null;
  };

  return (
    items?.length > 0 && (
      <div className={`news-grid news-grid--${items.length}-col`}>
        {items.map((item, index) => {
          const url = item.url || item.linkTo?.url;
          const isWithinLimit = !limit || index < limit;
          const imgObj = hasImage(item);

          if (!url || !isWithinLimit) return null;

          const showIntro =
            !hideText &&
            typeof (item.intro || item.bodyText) === "string" &&
            item.type?.toLowerCase() !== "nyhet";

          const size = items.length > 3 ? 600 : 1000;
          const placeholder = imgObj
            ? `${imgObj.url}?width=50&height=50&mode=crop&quality=20`
            : "";
          const src = imgObj
            ? `${imgObj.url}?width=${size}&height=${size}&mode=crop&quality=60${
                items.length <= 3 ? "&sharpen=10&sigma=1.5&threshold=10" : ""
              }`
            : "";
          const alt = imgObj?.alt || item.title || "";

          return (
            <InternalOrExternalLink
              key={item.id + "-news-grid-item"}
              to={url}
              style={{ minHeight }}
              className={`news-grid__item ${
                imgObj ? "" : "news-grid__item--no-bg"
              }`}
            >
              {imgObj && (
                <LazyBlur
                  placeholder={placeholder}
                  src={src}
                  alt={alt}
                  className="news-grid__item__bg"
                />
              )}

              {showIntro && (
                <p className="news-grid__item__text">
                  {hyphenParse(item.intro || item.bodyText)}
                </p>
              )}

              <div
                className="news-grid__item__overlay"
                style={{ opacity: imgObj ? "1" : "0" }}
              />

              <div className="news-grid__item__textwrapper">
                <div>
                  {typeof item.title === "string" && (
                    <div className="news-grid__item__textwrapper__title">
                      {hyphenParse(item.title)}
                    </div>
                  )}
                  {typeof url === "string" && (
                    <AnimateMount trigger={showUrl}>
                      <p className="small news-grid__item__textwrapper__url mt-2">
                        {hyphenParse(url)}
                      </p>
                    </AnimateMount>
                  )}
                </div>

                <div className="news-grid__item__textwrapper__arrow-right">
                  {icon || (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="33.763"
                      height="59.201"
                      viewBox="0 0 33.763 59.201"
                      className="news-grid__item__textwrapper__arrow-right"
                    >
                      <path
                        d="M5217.978,1504.771l26.521,25.359-26.521,25.358"
                        transform="translate(-5213.736 -1500.529)"
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </div>
              </div>
            </InternalOrExternalLink>
          );
        })}
      </div>
    )
  );
};

export default NewsGrid;
